import React, { Component } from 'react'
import { selectors, actions } from './sagas/reservation';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NavLink } from 'react-router-dom'
import './stylesheets/Cheers.sass'

class AccountCheers extends Component {
  render () {
    return (
    <div className={'cheers-page'}>
      <div className={'cheers-wrapper'}>
        <img alt='Cheers!' src={'Cheers.png'} />
        <div className={'cheers'}>
          Cheers!
        </div>
        <div className={'complete'}>
          You have sucessfully created a Kegmeisters account. You're ready to create products and check kegs into inventory.
        </div>
        <NavLink to='/bank_account_info'>
          <button className={'return-button'}>
            Get Started
          </button>
        </NavLink>
      </div>

    </div>
    )
  }
}

export default AccountCheers



// WEBPACK FOOTER //
// ./src/AccountCheers.jsx